import {startLoading, setData, setArchiveData} from "./cnASlice";
import axios from "axios";
import {zynity_api} from "../../../../../config/external-routes";

export const getCnAData = ({organization_id, team_id}: any) => {
    return async (dispatch: (arg0: { payload: any; type: string; }) => void, state: any) => {
        dispatch(startLoading())

        //Get Archive Data
        const user = state().auth
        const pastDate = state().tool_cna.pastDate;
        axios.defaults.headers.common = {'Authorization': `Bearer ${user.access_token}`}
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id) + '/tools/CnA?pastDate=' + pastDate;
        axios.get(`${url}&content_status=Archive`)
            .then((response) => {
                dispatch( setArchiveData(response.data) )
            }).catch((err) => {
            console.log('Error get cna Archive Data', err);
        })

        //Get Active Data
        axios.defaults.headers.common = {'Authorization': `Bearer ${user.access_token}`}
        await axios.get(zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id) + '/tools/CnA?pastDate=' + pastDate)
            .then((response) => {
                dispatch( setData(response.data) )
            }).catch((err) => {
                console.log('Error get cna Data', err);
            })
    }
}
